<template>
  <div>
    <div class="blue-subhead-bg text-uppercase">
    <h1>Dashboard</h1>
  </div>

  <div class="container admin-users">
    <br>
    <div class="row">
      <div class="col-sm-4 col-sm-offset-8">
        <a
          @click.prevent="addProgram"
          class="btn admin-btn-primary btn-lg btn-block text-uppercase">
          + Add new program
        </a>
      </div>
    </div>
    <div class="np-left-push hidden-xs">
      <div class="row">
        <div class="col-sm-2"><strong>Name</strong></div>
        <div class="col-sm-2"><strong>Client URL</strong></div>
        <div class="col-sm-2"><strong>Start Date</strong></div>
        <div class="col-sm-2"><strong>End Date</strong></div>
        <div class="col-sm-2"><strong>Unapproved Entries</strong></div>
      </div>
    </div>

    <transition-group name="slide-in">
      <div
        v-for="(program) in enabledPrograms" :key="program._id"
        class="blue-outline-nh">
        <div class="row">
          <div class="col-sm-2"><span class="visible-xs-inline-block"><strong>Name:</strong></span> {{ program.name }}</div>
          <div class="col-sm-2">
            <span class="visible-xs-inline-block">
              <strong>Client URL:</strong>
            </span>
            <!-- <a target="_blank" :href="`http://ec2-13-59-196-141.us-east-2.compute.amazonaws.com/program/${program.slug}/login`"> /program/{{ program.slug }}/login</a> -->
            <a href="" @click.prevent="doCopy(program.slug)"> /program/{{ program.slug }}/login</a>
          </div>
          <div class="col-sm-2"><span class="visible-xs-inline-block"><strong>Start Date</strong></span> {{ formatDate(program.startDate) }}</div>
          <div class="col-sm-2"><span class="visible-xs-inline-block"><strong>End Date </strong></span> {{ formatDate(program.endDate) }}</div>
          <div class="col-sm-2"><span class="visible-xs-inline-block"><strong>Unapproved Entries:</strong></span> {{ unapprovedUsers(program).length }}</div>
          <div class="col-sm-2 text-right">
            <a href="#" class="admin-clickable" @click.prevent="edit(program)"><strong>Details</strong></a> |
            <a
              v-if="!program.disabled"
              href="#"
              class="admin-clickable"
              @click.prevent="disable(program._id, program.name)">
              <strong>Disable</strong>
            </a>
            <a
              v-else
              href="#"
              class="admin-clickable"
              @click.prevent="enable(program._id)">
              <strong>Enable</strong>
            </a>
          </div>
        </div>
      </div>
    </transition-group>

    <a class="admin-clickable clickable" @click.prevent="toggleDisabled">Show Disabled</a>

    <transition name="toggle-disabled">
      <div v-if="showDisabled && disabledPrograms.length > 0">
        <hr>
        <div
          v-for="(program) in disabledPrograms" :key="program._id"
          class="blue-outline-nh">
          <div class="row">
            <div class="col-sm-2"><span class="visible-xs-inline-block"><strong>Name:</strong></span> {{ program.name }}</div>
            <div class="col-sm-2">
              <span class="visible-xs-inline-block">
                <strong>Client URL:</strong>
              </span>
              <!-- <a target="_blank" :href="`http://ec2-13-59-196-141.us-east-2.compute.amazonaws.com/program/${program.slug}/login`"> /program/{{ program.slug }}/login</a> -->
              <a href="" @click.prevent="doCopy(program.slug)"> /program/{{ program.slug }}/login</a>
            </div>
            <div class="col-sm-2"><span class="visible-xs-inline-block"><strong>Start Date</strong></span> {{ formatDate(program.startDate) }}</div>
            <div class="col-sm-2"><span class="visible-xs-inline-block"><strong>End Date </strong></span> {{ formatDate(program.endDate) }}</div>
            <div class="col-sm-2"><span class="visible-xs-inline-block"><strong>Unapproved Entries:</strong></span> {{ unapprovedUsers(program).length }}</div>
            <div class="col-sm-2 text-right">
              <a href="#" class="admin-clickable" @click.prevent="edit(program)"><strong>Details</strong></a> |
              <a
                v-if="!program.disabled"
                href="#"
                class="admin-clickable"
                @click.prevent="disable(program._id, program.name)">
                <strong>Disable</strong>
              </a>
              <a
                v-else
                href="#"
                class="admin-clickable"
                @click.prevent="enable(program._id)">
                <strong>Enable</strong>
              </a>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!-- COMPLETE THE PAGINATION -->
    <!-- <div class="row">
      <div class="col-sm-6 col-sm-offset-3 text-center">
        <nav aria-label="Page navigation">
          <ul class="pagination">
            <li>
              <a href="#" aria-label="Previous">
                <span aria-hidden="true">&laquo;</span>
              </a>
            </li>
            <li><a href="#">1</a></li>
            <li><a href="#">2</a></li>
            <li><a href="#">3</a></li>
            <li><a href="#">4</a></li>
            <li><a href="#">5</a></li>
            <li>
              <a href="#" aria-label="Next">
                <span aria-hidden="true">&raquo;</span>
              </a>
            </li>
          </ul>
        </nav>
      </div>
      <br>
    </div> -->
    <br><br>
  </div><!-- container-fluid -->
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'
import moment from 'moment'

export default {
  name: 'AdminDashboard',
  data () {
    return {
      showDisabled: false
    }
  },
  computed: {
    ...mapGetters('loyaltyProgram', [
      'enabledPrograms',
      'disabledPrograms'
    ]),
    ...mapState('loyaltyProgram', [
      'programs'
    ])
  },
  mounted () {
    this.getPrograms()
      .catch(err => console.log(err))
  },
  methods: {
    ...mapActions('loyaltyProgram', [
      'createProgram',
      'deleteProgram',
      'disableProgram',
      'enableProgram',
      'getPrograms'
    ]),
    ...mapMutations('loyaltyProgram', {
      setProgram: 'SET_PROGRAM',
      updateProgram: 'UPDATE_PROGRAM'
    }),
    async doCopy (slug) {
      // const base = 'http://ec2-13-59-196-141.us-east-2.compute.amazonaws.com/program/'
      const base = 'http://rewards.mercurydemo.com/program/'
      try {
        const copy = await this.$copyText(`${base}${slug}/login`)
        this.$bus.emit('notify', { message: 'URL copied to clipboard!', type: 'info' })
      } catch (error) {
        this.$bus.emit('notify', { message: 'Failed to copy URL to clipboard.' })
        console.log(error)
      }
    },
    addProgram () {
      this.createProgram()
        .then(() => this.$router.push({ name: 'NewProgramSetup' }))
        .catch(err => console.log(err))
    },
    modifyProgram (id) {
      this.editProgram(id)
      this.$router.push({ name: 'NewProgramSetup' })
    },
    removeProgram (id, name) {
      if (confirm(`Are you sure you want to delete ${name} program?`)) {
        this.deleteProgram(id)
          .catch(err => console.log(err))
      }
    },
    async disable (id, name) {
      try {
        if (confirm(`Are you sure you want to disable ${name} program?`)) {
          await this.disableProgram(id)
          this.$forceUpdate()
        }
      } catch (error) {
        console.log(error)
      }
    },
    async enable (id) {
      try {
        await this.enableProgram(id)
        this.$forceUpdate()
      } catch (error) {
        console.log(error)
      }
    },
    toggleDisabled () {
      if (this.showDisabled === false && this.disabledPrograms.length === 0) {
        return alert('There are no disabled programs to display')
      }
      this.showDisabled = !this.showDisabled
      this.$forceUpdate()
    },
    formatDate (date) {
      if (!date) return 'N/A'
      return moment(date).format('MM-DD-YYYY').toString()
    },
    edit (program) {
      this.setProgram(program)
      this.$router.push({ name: 'EditLoyaltyProgram' })
    },
    unapprovedUsers (program) {
      return program.userLoyaltyPrograms.filter(userProgram => !userProgram.approved)
    }
  }
}
</script>

<style scoped>
.blue-outline-nh .col-sm-2 {
  overflow-x: hidden;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.toggle-disabled-enter-active {
  transition: all .3s ease;
}

.toggle-disabled-leave-active {
  transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.toggle-disabled-enter, .toggle-disabled-leave-to {
  transform: translateY(100px);
  opacity: 0;
}

.slide-in-enter-active {
  transition: all .3s ease;
}

.slide-in-leave-active {
  transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-in-enter, .slide-in-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
</style>
